import { createDatasetSlice } from 'src/redux/helpers';
import { pepApiRequest, RequestMethod } from 'src/services';
import { generateApiPath } from 'src/utils';
import {
  API_SITE_WORKLOAD_CONFIGURATIONS,
  SITES_STORE,
  SITES_STORE_EDGE_WORKLOAD_CONFIGURATIONS,
} from '../constants';

const api = (siteId) =>
  pepApiRequest({
    method: RequestMethod.Get,
    url: generateApiPath(API_SITE_WORKLOAD_CONFIGURATIONS, { siteId }),
  }).then((response) => {
    if (!response) return { data: [] };
    const configurations = response?.workloadConfigurations ?? response;
    const data = Array.isArray(configurations)
      ? configurations.map((item) => {
          const config = item?.configuration ?? item;
          return {
            ...config,
            activeDeploymentCount: item?.activeDeploymentCount,
            totalDeploymentCount: item?.totalDeploymentCount,
            deploymentSummary: item?.deploymentSummary,
          };
        })
      : [];
    return { data };
  }).catch(() => ({ data: [] }));

const edgeWorkloadConfigurations = createDatasetSlice({
  api,
  storeName: SITES_STORE,
  actionName: SITES_STORE_EDGE_WORKLOAD_CONFIGURATIONS,
});

export default edgeWorkloadConfigurations;
